import MyCoverages from './Coverages';

export default MyCoverages